//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["controlItem"],
  data() {
    return {

      ThisDate : '',
      ThisDateExt: new Date(),
      // ThisDateExtMinDate: new Date(2019, 1, 1),
      // ThisDateExtMaxDate: new Date(2020, 10, 1),
      showDatePicker: false,

    };
  },
  created() {

    if(this.controlItem && this.controlItem.ControlValue){
        this.ThisDate = this.controlItem.ControlValue;
        this.ThisDateExt = this.$to.string2DateTime(this.ThisDate);
    }
  },

  methods: {


    onDatePickerClick() {
      this.showDatePicker = true;
      if (this.ThisDate) {
        this.ThisDateExt = this.$to.string2DateTime(this.ThisDate);
      }
    },

    onDatePickerConfirm(value) {
      console.log(value);
      this.ThisDate = this.$to.dateTime2String(value);
      this.controlItem.ControlValue = this.ThisDate;
      this.showDatePicker = false;
    },   


  }
};
